import React, { createContext, useContext, useState } from 'react';
import { TokenResponseModel, RegisterInputModel } from '../types/models';

interface SignupContextType {
  credentials: { email: string; password: string } | null;
  tokenResponse: TokenResponseModel | null;
  userProfile: Partial<RegisterInputModel>;
  setCredentials: (credentials: { email: string; password: string }) => void;
  setTokenResponse: (response: TokenResponseModel) => void;
  updateUserProfile: (data: Partial<RegisterInputModel>) => void;
}

export const SignupContext = createContext<SignupContextType | undefined>(
  undefined
);

export const SignupProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [credentials, setCredentials] = useState<{
    email: string;
    password: string;
  } | null>(null);
  const [tokenResponse, setTokenResponse] = useState<TokenResponseModel | null>(
    null
  );
  const [userProfile, setUserProfile] = useState<Partial<RegisterInputModel>>(
    {}
  );

  const updateUserProfile = (data: Partial<RegisterInputModel>) => {
    setUserProfile((prev) => ({ ...prev, ...data }));
  };

  return (
    <SignupContext.Provider
      value={{
        credentials,
        tokenResponse,
        userProfile,
        setCredentials,
        setTokenResponse,
        updateUserProfile,
      }}
    >
      {children}
    </SignupContext.Provider>
  );
};

export const useSignup = () => {
  const context = useContext(SignupContext);
  if (context === undefined) {
    throw new Error('useSignup must be used within a SignupProvider');
  }
  return context;
};
